"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * Hook that returns a function that provides tooltip message only when not hovering.
 * function returns object that can be used with spread operator on element like this: {...getSRTitle('title message')}
 */
exports.useSRTitle = function () {
    var _a = __read(react_1.useState(false), 2), mousedOver = _a[0], setMousedOver = _a[1];
    var getSRTitle = function (title, shouldHide) {
        if (shouldHide === void 0) { shouldHide = false; }
        return {
            title: !mousedOver && !shouldHide ? title : undefined,
            onMouseOver: function () { return setMousedOver(true); },
            onMouseOut: function () { return setMousedOver(false); },
        };
    };
    return getSRTitle;
};
